import { Component, OnInit, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { BaseFilterComponent } from '../base-filter.component';
import { FilterType } from '../../../../../core/enums/filter-type';
import { GuidFilterType } from '../../../../../core/services/api-services';
import { Filter } from '../../../../../core/models/filter';

@Component({
  selector: 'app-guid-filter',
  templateUrl: './guid-filter.component.html',
  styleUrls: ['./guid-filter.component.scss']
})
export class GuidFilterComponent extends BaseFilterComponent<GuidFilterType> implements OnInit {
  @Input() options: Observable<{ id: string, name: string }[]> = of([]);

  // StringFilterType
  guidFilterType = GuidFilterType;

  guidContainsFilter = GuidFilterType.Contains;

  filterForm = this.formBuilder.group({
    filterType: [GuidFilterType.Equals, [Validators.required]]
  });

  guidForm = this.formBuilder.group({
    value: ['', [Validators.required]]
  });

  multipleGuidForm = this.formBuilder.group({
    value: ['', [Validators.required]]
  });

  filterOptions = this.getFilterOptions();

  filterType: FilterType = FilterType.Guid;

  constructor(private readonly formBuilder: FormBuilder) {
    super();
  }

  getFilterOptions(): { value: number, translationKey: string }[] {
    const options: { value: number, translationKey: string }[] = [];

    Object.keys(GuidFilterType).filter((enumVal) => !isNaN(Number(enumVal))).forEach((enumVal: any) => {
      options.push({
        value: parseInt(enumVal, 10),
        translationKey: `Common.Filters.GuidFilters.${GuidFilterType[enumVal]}`
      });
    });

    return options;
  }

  ngOnInit(): void {
    this.currentValue
      .unsubscribeOnDestroy(this)
      .subscribe(value => {
        if (value) {
          this.filterChanged.emit({ filter: value, filterType: this.filterType, propertyName: this.propertyName });
          this.activeFilterField = value !== null;

          this.filterTypeControl.setValue(value.filterType);

          if (value.filterType !== GuidFilterType.Contains) {
            this.guidControl.setValue(value.values[0]);
          }
          else {
            this.multipleGuidControl.setValue(value.values);
          }
        }
      });

    if (this.initialValue) {
      this.currentValue.next(this.initialValue);
    }
  }

  clearFilter(): void {
    this.currentValue.next(null);
    this.activeFilterField = this.currentValue.value !== null;
    this.guidForm.reset();
    this.multipleGuidForm.reset();
  }

  onSubmit($event): void {
    if (this.filterTypeControl.value !== GuidFilterType.Contains) {     
      if (this.guidForm.valid) {
        const model: Filter<GuidFilterType> = {
          filterType: this.filterTypeControl.value,
          values: [this.guidControl.value, null] as any[],
          name: this.propertyName
        };

        this.currentValue.next(model);
      }
      else {
        $event?.stopPropagation();
      }
    }
    else {
      // Trigger form validation for untouched fields
      this.multipleGuidForm.markAllAsTouched();

      if (this.multipleGuidForm.valid) {
        const model: Filter<GuidFilterType> = {
          filterType: this.filterTypeControl.value,
          values: this.multipleGuidControl.value as any[],
          name: this.propertyName
        };

        this.currentValue.next(model);
      }
      else {
        $event?.stopPropagation();
      }
    }
  }

  onCancel(): void {
  }

  get guidControl(): FormControl {
    return this.guidForm.controls.value as FormControl;
  }

  get multipleGuidControl(): FormControl {
    return this.multipleGuidForm.controls.value as FormControl;
  }

  get filterTypeControl(): FormControl {
    return this.filterForm.controls.filterType as FormControl;
  }
}
